import { Link } from "react-router-dom";
import { Image, makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    logo: {
		display: "flex",
		alignItems: "center",
		textDecoration: "none",
		height: "60px"
	}
});

const NavigationMenuLogo = () => {
    const { t } = useTranslation("general");
    const styles = useStyles();
    
    return (
        <Link to="/">
            <Image
                src="/img/logos/dolphin-solutions_logo_blue-black.png"
                alt={t("companyName")}
                className={styles.logo}
                />
        </Link>
    );
};

export default NavigationMenuLogo;